import {


    CREATE_ORDER_REQUEST,
    CREATE_ORDER_SUCCESS,
    CREATE_ORDER_FAIL,
    CREATE_ORDER_RESET,


    ALL_ORDERS_REQUEST,
    ALL_ORDERS_SUCCESS,
    ALL_ORDERS_FAIL,

    ORDER_DETAILS_REQUEST,
    ORDER_DETAILS_SUCCESS,
    ORDER_DETAILS_FAIL,


    CREATE_REPORT_REQUEST,
    CREATE_REPORT_SUCCESS,
    CREATE_REPORT_RESET,
    CREATE_REPORT_FAIL,

    CREATE_REMARKS_REQUEST,
    CREATE_REMARKS_SUCCESS,
    CREATE_REMARKS_RESET,
    CREATE_REMARKS_FAIL,

    ORDER_REPORTS_REQUEST,
    ORDER_REPORTS_SUCCESS,
    ORDER_REPORTS_FAIL,

    UPDATE_REPORT_STATUS_REQUEST,
    UPDATE_REPORT_STATUS_SUCCESS,
    UPDATE_REPORT_STATUS_FAIL,
    UPDATE_REPORT_STATUS_RESET,



    CHART_DATA_REQUEST,
    CHART_DATA_SUCCESS,
    CHART_DATA_FAIL,


    CLEAR_ERRORS

} from "../constants/orderConstants";

export const createOrderReducer = (state = { order: {} }, action) => {

    switch (action.type) {
        case CREATE_ORDER_REQUEST:
            return {
                loading: true,
            };

        case CREATE_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message,
            };

        case CREATE_ORDER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null
            };

        case CREATE_ORDER_RESET:
            return {
                ...state,
                success: false,
                message: null
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};
export const allOrdersReducer = (state = { order: {} }, action) => {

    switch (action.type) {
        case ALL_ORDERS_REQUEST:
        case ORDER_DETAILS_REQUEST:
            return {
                loading: true,
            };

        case ALL_ORDERS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                orders: action.payload.orders,
                totalOrders: action.payload.totalOrders,
                totalPages: action.payload.totalPages,
                statusCounts: action.payload.statusCounts,
                orderedCount: action.payload.orderedCount,
                reviewedCount: action.payload.reviewedCount,
                onHoldCount: action.payload.onHoldCount,
                deliveredCount: action.payload.deliveredCount,
                refundedCount: action.payload.refundedCount,
                commissionedCount: action.payload.commissionedCount,
                completedCount: action.payload.completedCount,
                cancelledCount: action.payload.cancelledCount,
                reviewDeletedCount: action.payload.reviewDeletedCount,
            };
        case ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                order: action.payload.order,
                orderLogs: action.payload.orderLogs,
                orderRemarks: action.payload.orderRemarks
            };

        case ALL_ORDERS_FAIL:
        case ORDER_DETAILS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };


        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};

export const orderReportsReducer = (state = { order: {} }, action) => {

    switch (action.type) {
        case ORDER_REPORTS_REQUEST:
            return {
                loading: true,
            };

        case ORDER_REPORTS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                reports: action.payload.reports,
                totalPages: action.payload.totalPages,
                resolved_count: action.payload.resolved_count,
                pending_count: action.payload.pending_count,
                rejected_count: action.payload.rejected_count,
                under_review_count: action.payload.under_review_count,
            };

        case ORDER_REPORTS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null
            };



        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};
export const createReportReducer = (state = { order: {} }, action) => {

    switch (action.type) {
        case CREATE_REPORT_REQUEST:
        case UPDATE_REPORT_STATUS_REQUEST:
        case CREATE_REMARKS_REQUEST:
            return {
                loading: true,
            };

        case CREATE_REPORT_SUCCESS:
        case UPDATE_REPORT_STATUS_SUCCESS:
        case CREATE_REMARKS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message,
            };

        case CREATE_REPORT_RESET:
        case UPDATE_REPORT_STATUS_RESET:
        case CREATE_REMARKS_RESET:
            return {
                ...state,
                loading: false,
                success: false,
                message: null
            };

        case CREATE_REPORT_FAIL:
        case UPDATE_REPORT_STATUS_FAIL:
        case CREATE_REMARKS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};



export const chartDataReducer = (state = { order: {} }, action) => {

    switch (action.type) {
        case CHART_DATA_REQUEST:
            return {
                loading: true,
            };

        case CHART_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                chart: action.payload,
            };


        case CHART_DATA_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };


        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};


export const exportOrdersReducer = (state = { order: {} }, action) => {

    switch (action.type) {
        case "EXPORT_ORDERS_REQUEST":
            return {
                loading: true,
            };

        case "EXPORT_ORDERS_SUCCESS":
            return {
                ...state,
                loading: false,
                success: true,
            };
        case "EXPORT_ORDERS_FAIL":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };


        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};
